/**
 * Jambuveda product page (v3 — bottle-quantity tiers)
 * - Each product now has exactly ONE real Shopify variant (real SKU,
 *   real inventory). Tier buttons no longer switch variants — they set
 *   the quantity added to cart (1, 2, or 3 bottles).
 * - The headline price (₹X/month) is a STATIC marketing hook — the
 *   best possible per-bottle rate at the 3-bottle tier, shown upfront
 *   to pull people in. It intentionally does NOT change when a tier is
 *   clicked; the real, accurate price for whichever tier someone picks
 *   is already shown clearly on that tier's own card.
 * - AJAX add to cart via Shopify /cart/add.js, then refreshes and opens
 *   the cart drawer (fixed: previously just called .open() on stale
 *   content, showing an empty drawer on first add).
 */
(function () {
  const root = document.querySelector('.jv-pdp');
  if (!root) return;

  const idInput   = root.querySelector('[data-jv-variant-id]');
  const qtyInput  = root.querySelector('[data-jv-qty]');
  const addBtn    = root.querySelector('[data-jv-add]');
  const addText   = root.querySelector('[data-jv-add-text]');

  // ---- tier selection: sets quantity only, headline price stays fixed ----
  const tierGroup = root.querySelector('[data-jv-tiers]');
  if (tierGroup) {
    tierGroup.querySelectorAll('[data-jv-tier-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        tierGroup.querySelectorAll('[data-jv-tier-qty]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const qty = parseInt(btn.dataset.jvTierQty, 10) || 1;
        if (qtyInput) qtyInput.value = qty;
      });
    });
  }

  // ---- AJAX add to cart ----
  const form = document.getElementById('jv-pdp-form');
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (addBtn.hasAttribute('disabled')) return;
    const prev = addText.textContent;
    addText.textContent = 'Adding…';
    addBtn.setAttribute('disabled', '');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(idInput.value), quantity: Number(qtyInput.value) || 1 })
      });
      if (!res.ok) throw new Error('add failed');

      addText.textContent = 'Added ✓';

      document.dispatchEvent(new CustomEvent('jv:cart:added'));
      const drawer = document.querySelector('cart-drawer, #CartDrawer, [id*="cart-drawer"]');
      if (drawer && typeof drawer.renderContents === 'function') {
        // Dawn's cart-drawer needs fresh section HTML before it opens —
        // calling .open() alone just opens whatever was already in the
        // DOM (empty, on first add). Fetch the live sections and hand
        // them to the drawer's own render method, which opens it once
        // the real cart contents are in place.
        try {
          const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          const sections = await sectionsRes.json();
          drawer.renderContents({ id: Number(idInput.value), sections });
        } catch (sectionsErr) {
          console.error('Jambuveda cart drawer refresh error', sectionsErr);
          if (typeof drawer.open === 'function') drawer.open();
        }
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        setTimeout(() => { window.location.href = '/cart'; }, 500);
      }
      setTimeout(() => { addText.textContent = prev; addBtn.removeAttribute('disabled'); }, 1500);
    } catch (err) {
      console.error('Jambuveda add-to-cart error', err);
      addText.textContent = 'Try again';
      addBtn.removeAttribute('disabled');
      setTimeout(() => { addText.textContent = prev; }, 1500);
    }
  });
})();
